import { Source } from "."

export const COLORS = {
  [Source.WIKI]: '#ABFA7E',
  [Source.RESTROOM]: '#F5CEE1',
  [Source.CUSTOM]: '#9BD4F4',
  [Source.AD]: '#9BD4F4'
}